module.exports = __webpack_public_path__ + "img/antes_despues_174.0cc4d8d8.png";